module.exports = __webpack_public_path__ + "media/images/image-louise-biceps-aa20ef82.jpg";